import React, { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './components/Header';
import Hero from './components/Hero';
import Strengths from './components/Strengths';
import Results from './components/Results';
import CopyTrading from './components/CopyTrading';
import HowItWorks from './components/HowItWorks';
import ReferralProgram from './components/ReferralProgram';
import FAQ from './components/FAQ';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import NotFound from './components/NotFound';
import CanonicalUrl from './components/CanonicalUrl';
import CookieConsent from './components/CookieConsent';
import { setupScrollAnimation } from './utils/AnimateOnScroll';

function MainContent() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setupScrollAnimation();

    // Force load the correct language from localStorage
    const savedLang = localStorage.getItem('i18nextLng');
    if (savedLang && savedLang !== i18n.language) {
      console.log('Forcing language change to:', savedLang);
      i18n.changeLanguage(savedLang);
    }

    document.title = t('meta.title');

    // Debug: log current language
    console.log('=== Language Debug ===');
    console.log('Current i18n language:', i18n.language);
    console.log('Current i18n resolved language:', i18n.resolvedLanguage);
    console.log('LocalStorage i18nextLng:', localStorage.getItem('i18nextLng'));
    console.log('Available languages:', i18n.languages);
    console.log('Has loaded namespace:', i18n.hasLoadedNamespace('translation'));
    console.log('Sample translation (hero.title):', t('hero.title'));
    console.log('=====================');
  }, [t, i18n]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main>
        <Hero />
        <Strengths />
        <Results />
        <HowItWorks />
        <CopyTrading />
        <ReferralProgram />
        <FAQ />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}

function LoadingFallback() {
  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center">
      <div className="text-gradient-from text-xl">Loading...</div>
    </div>
  );
}

function App() {
  return (
    <Router basename="/">
      <Suspense fallback={<LoadingFallback />}>
        <CanonicalUrl />
        <Routes>
          <Route path="/" element={<MainContent />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieConsent />
      </Suspense>
    </Router>
  );
}

export default App;